var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"main-wrapper"}},[_c('clubnavigation'),_c('div',{},[_c('clubsidebar')],1),_c('div',{staticClass:"content-wrapper club-mb",attrs:{"id":"content-wrapper"}},[_c('div',{staticClass:"mb-5"},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('clubdboardfooter')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }